import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiAward,FiUsers,FiTrendingUp,FiTarget}=FiIcons;

const About=()=> {
  const achievements=[
    {icon: FiAward,value: '25+',label: 'Years Experience'},
    {icon: FiUsers,value: '500+',label: 'Clients Served'},
    {icon: FiTrendingUp,value: '95%',label: 'Success Rate'},
    {icon: FiTarget,value: '50+',label: 'Major Projects'}
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{opacity: 0,x: -50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          >
            <div className="relative">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759003344880-IMG_0240.jpg"
                alt="Leigh Klein - Sports Industry Consultancy"
                className="rounded-3xl shadow-2xl border border-gray-100 w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-900/20 to-transparent rounded-3xl"></div>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,x: 50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                About <span className="text-orange-600"> Leigh Klein</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                A leading sports industry consultancy with over 25 years of experience in business development, marketing strategy, and revenue growth across collegiate and professional sports organizations.
              </p>
              <p className="text-gray-600 leading-relaxed mb-6">
                Currently serving as the founder and host of "That Bracket Show," a leading college basketball analytics and entertainment platform. Specializes in sales and business development for sports teams, sports events and sports media organizations.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Passionate about leveraging strategic sales approaches and business development expertise to drive measurable growth and create lasting value for clients across the sports industry.
              </p>
            </div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.8,delay: 0.3}}
            >
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Core Expertise</h3>
              <div className="space-y-4">
                {[
                  'Sales & Business Development for Sports Teams',
                  'Sports Events Marketing & Revenue Growth', 
                  'Sports Media Sales & Partnership Development',
                  'Strategic Consulting & Client Acquisition'
                ].map((expertise,index)=> (
                  <motion.div
                    key={expertise}
                    initial={{opacity: 0,x: -20}}
                    whileInView={{opacity: 1,x: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6,delay: index * 0.1}}
                    className="flex items-center"
                  >
                    <div className="w-2 h-2 bg-orange-600 rounded-full mr-4"></div>
                    <span className="text-gray-700">{expertise}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </motion.div>
        </div>

        <motion.div
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8,delay: 0.5}}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20"
        >
          {achievements.map((achievement,index)=> (
            <motion.div
              key={achievement.label}
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: index * 0.1}}
              whileHover={{scale: 1.05}}
              className="text-center p-6 rounded-2xl bg-gray-50 hover:bg-orange-50 transition-all duration-300 border border-gray-100"
            >
              <SafeIcon icon={achievement.icon} className="w-8 h-8 text-orange-600 mx-auto mb-4" />
              <div className="text-3xl font-bold text-gray-900 mb-2">{achievement.value}</div>
              <div className="text-gray-600 text-sm">{achievement.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default About;